import AdmissaoView from "../../components/rh/AdmissaoView";

export default function AdmissaoRh() {
  return <AdmissaoView />;
}
